import { createStore } from 'vuex'

let images = {
  logo:require("../assets/96x96.png"),
  list_icon:require('../assets/list_icon.png'),
  IATA_logo:require("../assets/IATA_logo.png")
}

export default createStore({
  state: {
    images:images,
    resolveData:{
      AirlineBigCode: null,
      Pnr: "",
      Airline: "",
      DateOfIssue: "",
      AirNo: "",
      Tickets: [],
      Flights: [],
    },
    adminName:'',
    phone:'',
    fax:'',
    seledLetter:'ch',
    seledPDF:'many',
    dataTickets:[
      {
        PersonName:'',
        Certificate:''
      }
    ]
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
